import React from 'react';
import { formatShortDate } from '../../utils/date-utils';
import { CheckCircle2, Clock, CalendarClock, HardHat, AlertTriangle } from 'lucide-react';

const INK    = '#2B2620';
const MOSS   = '#3B6B44';
const OCHRE  = '#A6752A';
const RUST   = '#A13D2D';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';
const FONT_SANS = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const warningTypes = {
  on_hold:         { Icon: Clock,         color: OCHRE },
  old_unscheduled: { Icon: CalendarClock, color: OCHRE },
  long_lead_time:  { Icon: CalendarClock, color: OCHRE },
  crew_overload:   { Icon: HardHat,       color: RUST },
  missing_info:    { Icon: AlertTriangle, color: RUST },
};

export default function SoftWarnings({ warnings = [] }) {
  if (warnings.length === 0) {
    return (
      <div style={{
        padding: '20px',
        background: PAPER,
        borderRadius: '14px',
        border: '1px solid rgba(139,69,19,0.1)',
        boxShadow: '0 2px 12px rgba(139,69,19,0.06)',
        fontFamily: FONT_SANS,
      }}>
        <h3 style={{
          fontSize: '15px',
          fontWeight: '600',
          color: INK,
          marginBottom: '16px'
        }}>
          Alerts & Warnings
        </h3>

        <div style={{
          padding: '40px 20px',
          textAlign: 'center'
        }}>
          <CheckCircle2 size={36} strokeWidth={1.5} color={MOSS} style={{ marginBottom: '12px' }} />
          <div style={{
            fontSize: '14px',
            fontWeight: '600',
            color: MOSS,
            marginBottom: '4px'
          }}>
            All Clear!
          </div>
          <div style={{
            fontSize: '13px',
            color: STONE
          }}>
            No warnings or alerts at this time
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      padding: '20px',
      background: PAPER,
      borderRadius: '14px',
      border: '1px solid rgba(139,69,19,0.1)',
      boxShadow: '0 2px 12px rgba(139,69,19,0.06)',
      fontFamily: FONT_SANS,
    }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '16px'
      }}>
        Alerts & Warnings
      </h3>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px'
      }}>
        {warnings.map((warning, index) => {
          const type = warningTypes[warning.type] || warningTypes.missing_info;

          return (
            <div
              key={index}
              style={{
                padding: '12px 14px',
                background: `${type.color}0d`,
                border: `1px solid ${type.color}30`,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px'
              }}
            >
              <type.Icon size={16} strokeWidth={2} color={type.color} style={{ flexShrink: 0, marginTop: '1px' }} />

              <div style={{ flex: 1 }}>
                <div style={{
                  fontSize: '13px',
                  fontWeight: '600',
                  color: INK,
                  marginBottom: '4px'
                }}>
                  {warning.title}
                </div>
                <div style={{
                  fontSize: '12px',
                  color: STONE
                }}>
                  {warning.message}
                </div>

                {warning.job && (
                  <div style={{
                    fontSize: '11px',
                    color: type.color,
                    marginTop: '6px',
                    fontWeight: '600'
                  }}>
                    Job #{warning.job.contractNumber} - {warning.job.customerName}
                    {warning.job.soldDate && ` (Sold: ${formatShortDate(warning.job.soldDate)})`}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
